import { render, staticRenderFns } from "./MyView.vue?vue&type=template&id=42c84542&scoped=true&"
import script from "./MyView.vue?vue&type=script&lang=js&"
export * from "./MyView.vue?vue&type=script&lang=js&"
import style0 from "./MyView.vue?vue&type=style&index=0&id=42c84542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c84542",
  null
  
)

export default component.exports